<template>
  <div class="background">
    <div class="particles">
      <!-- <Particles :min-particle-size="90" :max-particle-size="90" :images="particles" :one-particle-per-image="true" /> -->
    </div>

    <div class="banner-mask">
      <div class="banner" :style="bannerStyles">
        <div class="intro">
          <h1 class="title">{{ evEvent.title }}</h1>
          <p class="subtitle">{{ subtitle }}</p>
          <p class="description">{{ evEvent.info_description }}</p>
        </div>
      </div>
    </div>

    <div class="courses">
      <div v-for="(topic, i) in evEventTopics" :key="`${topic.title}-${i}`" class="topic">
        <p class="topic-title">Chapter {{ numbers[i] }} : {{ topic.title }}</p>

        <ul class="course-list">
          <li v-for="(course, j) in evTopicCourses[topic.id]" :key="`${course.id}-${j}`" class="course">
            <EventAccordion :course="course" :number="j + i" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, computed } from 'vue';

// import $assets from '@/assets';
import EventAccordion from '@/components/event/EventAccordion.vue';
// import Particles from '@/components/event/Particles.vue';
import EventService from '@/services/event';
import $conversion from '@/utils/conversion';

const props = defineProps({
  eventId: {
    type: [String, Number],
    default: 0,
  },
});

const evEvent = ref({});
const evEventTopics = ref([]);
const evTopicCourses = ref([]);
const numbers = ref(['One', 'Two', 'Three', 'Four']);

// const particles = computed(() => {
//   return [
//     $assets.image['particle_1.png'],
//     $assets.image['particle_2.png'],
//     $assets.image['particle_3.png'],
//     $assets.image['particle_4.png'],
//     $assets.image['particle_5.png'],
//     $assets.image['particle_6.png'],
//   ];
// });
const bannerStyles = computed(() => {
  return {
    // || '' is avoiding undefined value
    // This evEvent is from database instead of props,
    // so before evEvent get data, url will receive a undefined
    backgroundImage: `url(${evEvent.value.info_banner || ''})`,
  };
});
const dates = computed(() => {
  if (!evEvent.value.start_date || !evEvent.value.end_date) {
    return 'Coming Soon';
  }

  const options = { dateStyle: 'long' };
  const startDate = evEvent.value.start_date.toLocaleString('en-CA', options);
  const endDate = evEvent.value.end_date.toLocaleString('en-CA', options);

  return `${startDate} - ${endDate}`;
});
const subtitle = computed(() => {
  return `${evEvent.value.type_text} | ${dates.value}`;
});

onBeforeMount(async () => {
  const eventResult = await EventService.getEvent(props.eventId);
  evEvent.value = $conversion.eventToUI(eventResult.record);

  const topicResults = await EventService.getEventTopics(evEvent.value.id);
  evEventTopics.value = topicResults.records;

  const courseResults = await EventService.getEventCourses(evEvent.value.id);
  evTopicCourses.value = courseResults.records.reduce((o, course) => {
    const obj = o;

    if (!obj[course.topic_id]) {
      obj[course.topic_id] = [];
    }

    // Make all fields work with ui logic
    const courseUIData = $conversion.courseToUI(course);

    obj[course.topic_id].push(courseUIData);

    return obj;
  }, {});
});
</script>

<style scoped>
.background {
  position: relative;

  min-height: calc(100% - 580px);
  padding-top: 490px;
  padding-bottom: 90px;
  overflow-x: hidden;
}

@media (min-width: 1440px) {
  .background {
    font-size: 18px;
  }
}

.particles {
  position: absolute;
  top: 0px;
  width: 100%;
  height: calc(100%);

  background: linear-gradient(180deg, #53a4bf 0%, #1f184b 100%);
}

.banner-mask {
  position: absolute;
  top: -156px;
  left: -28%;
  width: 156%;
  height: 810px;

  border-radius: 50%;
  overflow: hidden;
}

.banner {
  position: relative;
  top: 156px;
  left: 17.9%;
  width: 64.1%;
  height: 654px;
  padding: 0;
  margin: 0;

  background: transparent;
  background-size: cover;
}

.banner .intro {
  position: absolute;
  top: 40px;
  left: 30px;
  width: calc(100% - 60px);
  max-width: 50em;

  color: white;
  font-family: Helvetica, sans-serif;
}

.title {
  color: inherit;
  font-weight: normal;
}

.courses {
  position: relative;
  max-width: 1786px;
  margin: 0 1.8em;
  padding: 44px 20px;
  font-size: 1em;

  background: rgba(89, 202, 215, 0.81);
  box-shadow: 0 2px 18px 0 rgba(0, 0, 0, 0.5);
  border-radius: 14px;
  overflow: hidden;
}

.courses::before {
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  display: block;
  content: '';
  backdrop-filter: blur(5px);
}

@media screen and (min-width: 1960px) {
  .courses {
    margin: 0 auto;
  }
}

.topic {
  position: relative;
  font-size: 10px;
}

.topic-title {
  font-family: Helvetica;
  font-size: 1.3em;
  color: white;
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .banner .intro {
    top: 118px;
    left: 87px;
  }

  .courses {
    margin: 0 5.8em;
    padding: 44px 53px;
  }

  .topic {
    font-size: 15px;
  }
}
</style>
